import _extends from "@babel/runtime/helpers/esm/extends";
import PropTypes from 'prop-types';
import React, { forwardRef, useContext } from 'react';
import { PageContext } from '../Page/Page.context';
import { StyledPageContent } from './PageContent.styles';

/**
 * Page content is a generic container that provides a consistent layout
 * for all `Page` components. It sets the max-width and defines
 * default padding and margins.
 *
 * You can use this component with your own custom components to make sure layouts are consistent.
 *
 * @since 8.15.0
 */
export var PageContent = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var _useContext = useContext(PageContext),
    fluid = _useContext.fluid;
  return /*#__PURE__*/React.createElement(StyledPageContent, _extends({
    ref: forwardedRef,
    fluid: fluid
  }, props));
});
PageContent.displayName = 'PageContent';
PageContent.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * By default, page components will be bound by the `Page.maxWidth` token.
   * Setting this to true will remove the max width bound.
   *
   * Setting this on `Page` will set `fluid` for all child page components.
   */
  fluid: PropTypes.bool
} : {};